import { TipoControl } from './formulario-dinamico.model';

/**
 * Modelo de vista dinamica
 *
 * @export
 * @class VistaDinamica
 */
export class VistaDinamica {
  nombre: string;
  descripcion: string;
  id: number;
  tramite_destino: DetalleTramiteDestino;
  tramites: TramitesVista[];
  multiples: boolean;
  filtro: boolean;
}

/**
 * Modelo del detalle de el tramite de destino de una vista
 *
 * @export
 * @class DetalleTramiteDestino
 */
export class DetalleTramiteDestino {
  nombre: string;
  id: number;
  roles: RolTramiteDestino[];
}

/**
 * Modelo del rol del tramite de destino de una vista
 *
 * @export
 * @class RolTramiteDestino
 */
export class RolTramiteDestino {
  nombre: string;
  descripcion: string;
  id: number;
}

/**
 * Modelo detalle de una vista
 *
 * @export
 * @class DetalleVistaDinamica
 * @extends {VistaDinamica}
 */
export class DetalleVistaDinamica extends VistaDinamica {
  estructura: EstructuraVistaDinamica[];
  acciones: AccionVista[];
}

/**
 * Modelo estructura dinamica de una vista
 *
 * @export
 * @class EstructuraVistaDinamica
 */
export class EstructuraVistaDinamica {
  nombre: string;
  id: number;
  orden: number;
  tipo: TipoControl;
  tramites: number[];
  propiedades: any;
  condiciones: any;
}

/**
 * Modelo tramites de origen de una vista
 *
 * @export
 * @class TramitesVista
 */
export class TramitesVista {
  tramite: string;
  proceso: string;
  categoria: string;
  id: number;
}

/**
 * Modelo acciones a realizar en una vista
 *
 * @export
 * @class AccionVista
 */
export class AccionVista {
  nombre: string;
  propiedades: any;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/vistas-dinamicas.model.ts